import { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react"

import { useNavigate } from "react-router-dom"
import timerbg from "../utills/images/timer.png"
import Director from "../Components/Director";
import Heading from "../Components/Heading";
import QuestionScreen from "../Components/QuestionScreen";

const Startgame = () => {
  let navigate = useNavigate();

  const [score, setScore] = useState({
    "directorScore": 0,
    "headingScore": 0,
    "questionScore": 0,
  })

  const [elapsedTime, setElapsedTime] = useState(0);
  const totalTime = 5*60; // 5 minutes in seconds
  const minutes = Math.floor((totalTime - elapsedTime) / 60);
  const ms = elapsedTime % 60;

  useEffect(() => {
    if (minutes < 0) {
      let totalScore = Math.floor((score.headingScore + score.directorScore+score.questionScore) / 3);
      let difficulty = localStorage.getItem("difficulty");
      let userScore = JSON.parse(localStorage.getItem("flightControlscore"));
      localStorage.setItem("flightControlscore", JSON.stringify({ ...userScore, [difficulty]: totalScore }))

      navigate("/result", {
        state: { totalScore: totalScore, headingScore: score.headingScore, directorScore: score.directorScore, questionScore: score.questionScore }
      });
    }
    const intervalId = setInterval(() => {
      setElapsedTime(prevElapsedTime => prevElapsedTime + 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [elapsedTime]);

  const handleScoreChange = (newScore, name) => {
    setScore({ ...score, [name]: newScore });
  }



  return (
    <Box bg="aquamarine" paddingBottom="50px" >
      <Box style={{ "box-shadow": "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset" }} fontSize={"20px"} fontWeight={"bold"} bgImage={timerbg} bgSize={"cover"} width={"148px"} display={"flex"} h={"50px"} m={"20px"} textAlign={"center"} justifyContent={"center"} p={"10px"} margin={"auto"}>
        <text >
          {minutes < 10 ? `0${minutes}` : minutes}:{ms < 10 ? `0${ms}` : ms}
        </text>
      </Box>
      <Box
        bg="aquamarine"
        display="flex"
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent={"space-evenly"}
        alignItems="center"
        rowGap={"10px"}
      >
        <Box w={"325px"} borderRadius={"15px"} bg={"white"} height={"400px"} border={"10px solid gray"} display={"flex"} flexDirection={"column"} justifyContent={"center"} >
          <Box margin={"auto"}>
            <Director onScoreChange={handleScoreChange} />
          </Box>
          <Box m={"auto"}>
            <Heading onScoreChange={handleScoreChange} />
          </Box>
        </Box>
        {/* ..............Questions ...........  */}
        <Box w={"325px"} borderRadius={"15px"} bg={"white"} height={"400px"} border={"10px solid gray"} >
          <QuestionScreen onScoreChange={handleScoreChange} display={"flex"} flexDirection={"column"} justifyContent={"center"} />
        </Box>
      </Box>
    </Box >
  )
}

export default Startgame